<template>
  <div class="bg">
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="container">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h1 class="display-1 text-uppercase text-primary">About Us</h1>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-3 mt-4">
            <figure class="walden">
              <router-link to="/contact">
                <img class="" src="img/Steve Thurmond Bio Pic.jpeg">
              </router-link>
            </figure>
          </div>
          <div class="col-lg-9">
            <p class="lead text-dark">Steve Thurmond is the owner and founder of Forward Financial, LLC, which specializes in insurance, financial planning and retirement income solutions for families and individuals at any stage of life. We collaborate with accountants, attorneys and estate planners to provide the best possible advice and service to our clients. We take a comprehensive, 21-step approach to advising clients on the many aspects of financial planning and insurance solutions. Steve is a <a href="https://nationalcffassociation.org/" target="_blank">Certified Financial Fiduciary</a> and holds Life, Health, Property, Casualty and Legal Insurance licenses in 35 states from coast to coast.</p>
            <p class="lead text-dark">Forward Financial exists to provide all of the tools, information, and resources you need for planning your financial future. Our mission is to offer intelligent insurance and financial strategies that result in clarity, security, and health. Forward Financial empowers you with personalized strategies to help you reach your goals.</p>
          </div>
        </div>
        <hr>
        <div class="row mt-5">
          <div class="col-4">
            <icon name="fa fa-clock-o" size="lg" type="success" shadow round color="primary"></icon>
            <h5 class="text-primary mt-3">History</h5>
            <p class="text-dark mt-3">Forward Financial was founded in 2019 by owner and Certified Financial Fiduciary, Steve Thurmond.</p>
          </div>
          <div class="col-4">
            <icon name="fa fa-fire" size="lg" type="success" shadow round color="primary"></icon>
            <h5 class="text-primary mt-3">Passion</h5>
            <p class="text-dark mt-3">From insuring your every day life to planning your future, Forward Financial grows every year with the needs of our valued clients.</p>
          </div>
          <div class="col-4">
            <icon name="fa fa-arrows" size="lg" type="success" shadow round color="primary"></icon>
            <h5 class="text-primary mt-3">Growth</h5>
            <p class="text-dark mt-3">Forward Financial strives to meet the needs of our clients by rapidly expanding our offerings. Contact us today to ask about our latest services.</p>
          </div>
        </div>
        <hr>
      </div>
    </section>
    <contact />
  </div>
</template>

<script>
import Contact from './Contact.vue'
export default {
  name: "About",
  components: {
    Contact
  }
};
</script>
